import { render, staticRenderFns } from "./WaiterDialog.vue?vue&type=template&id=57538e36&scoped=true"
import script from "./WaiterDialog.vue?vue&type=script&lang=js"
export * from "./WaiterDialog.vue?vue&type=script&lang=js"
import style0 from "./WaiterDialog.vue?vue&type=style&index=0&id=57538e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57538e36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSnackbar})
